import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Form, Col } from 'react-bootstrap';
import { FORM_MODE } from '@awp/constants';
import { getBreakpoints } from '@awp/helpers/UIHelper';
import { debounce } from '@awp/helpers/Utils';
import GraphPresetTable from './GraphPresetTable';
import GraphPresetEdit from './GraphPresetEdit';
import { selectCurrentUser } from '@stores/usersSlice';
import { AwpContainer } from '@awp/components/Common/AwpContainer';

const GraphPresets = () => {
  const [mode, setMode] = useState(FORM_MODE.LIST);
  const [title, setTitle] = useState('Graph Presets');
  const [breakpoints, setBreakpoints] = useState(getBreakpoints());
  const [loading, setLoading] = useState(false);
  const [fullData, setFullData] = useState([]);
  const [index, setIndex] = useState(0);
  const [sort, setSort] = useState([{ id: 'Name', desc: false }]);
  const [presetId, setPresetId] = useState(null);
  const [defaultPageSize, setDefaultPageSize] = useState(25);
  const currentUser = useSelector(selectCurrentUser);

  const wrapper = useRef(null);

  useEffect(() => {
    const handleResize = debounce(() => {
      setBreakpoints(getBreakpoints());
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const tableProps = {
    title,
    breakpoints,
    currentUser,
    setLoading,
    loading,
    setMode,
    mode,
    index,
    setIndex,
    presetId,
    setPresetId,
    sort,
    setSort,
    defaultPageSize,
    setDefaultPageSize,
  };

  const editProps = {
    setMode,
    mode,
    setPresetId,
    presetId,
    setLoading,
    loading,
    currentUser,
  };

  if (mode === FORM_MODE.LIST) {
    return (
      <AwpContainer>
        <GraphPresetTable {...tableProps} />
      </AwpContainer>
    );
  } else {
    return (
      <AwpContainer>
        <GraphPresetEdit {...editProps} ref={wrapper} />
      </AwpContainer>
    );
  }
};

export default GraphPresets;
